(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["umg-header"]) return;
  try {
    
  function setMenuExpanded(toggle, expanded) {
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute('aria-label', expanded ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    if (!expanded) toggle.closest('.umg-nav')?.querySelectorAll('[data-umg-mega-menu]').forEach(menu => { menu.open = false; });
  }

  function updateCurrentMenuLink() {
    const current = new URL(window.location.href);
    const normalizePath = path => path.replace(/\/+$/, '') || '/';
    const matchesCurrent = href => {
      let selected = false;
      try {
        const target = new URL(href, current);
        selected = target.origin === current.origin && normalizePath(target.pathname) === normalizePath(current.pathname);
        for (const [key, value] of target.searchParams) {
          if (current.searchParams.get(key) !== value) selected = false;
        }
      } catch {}
      return selected;
    };
    document.querySelectorAll('.umg-menu-links > a, .umg-mega-grid a, .umg-mega-footer a').forEach(link => {
      const selected = matchesCurrent(link.getAttribute('href'));
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-umg-mega-menu]').forEach(menu => {
      const summary = menu.querySelector('summary');
      const selected = matchesCurrent(summary.dataset.umgCurrentUrl) || Boolean(menu.querySelector('a[aria-current="page"]'));
      summary.dataset.current = String(selected);
    });
  }

  function initializeMenus() {
    updateCurrentMenuLink();
    document.querySelectorAll('[data-umg-mega-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const grid = menu.querySelector('.umg-mega-grid');
      if (menu.dataset.randomize === 'true' && grid) {
        const items = [...grid.children];
        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [items[i], items[j]] = [items[j], items[i]];
        }
        grid.append(...items);
      }
      const closeSiblings = () => {
        menu.closest('.umg-nav').querySelectorAll('[data-umg-mega-menu]').forEach(other => { if (other !== menu) other.open = false; });
      };
      menu.addEventListener('toggle', () => { if (menu.open) closeSiblings(); });
      menu.querySelector('summary').addEventListener('click', event => {
        if (event.detail > 0 && menu.open && window.matchMedia('(min-width: 851px) and (hover: hover) and (pointer: fine)').matches) event.preventDefault();
      });
      menu.addEventListener('pointerenter', () => {
        if (!window.matchMedia('(min-width: 851px) and (hover: hover) and (pointer: fine)').matches) return;
        closeSiblings();
        menu.open = true;
      });
      menu.addEventListener('pointerleave', () => {
        if (!window.matchMedia('(min-width: 851px) and (hover: hover) and (pointer: fine)').matches) return;
        if (!menu.contains(document.activeElement)) menu.open = false;
      });
      menu.addEventListener('focusout', event => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
      });
    });
    document.querySelectorAll('[data-umg-menu-toggle]').forEach(toggle => {
      const navigation = toggle.closest('.umg-nav');
      if (!navigation || navigation.classList.contains('umg-menu-ready')) return;
      if (!document.getElementById(toggle.getAttribute('aria-controls'))) return;
      setMenuExpanded(toggle, false);
      navigation.classList.add('umg-menu-ready');
    });
  }

  document.addEventListener('click', event => {
    document.querySelectorAll('[data-umg-mega-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
    const toggle = event.target.closest('[data-umg-menu-toggle]');
    if (!toggle) return;
    setMenuExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-umg-mega-menu][open]');
    if (menu) {
      event.preventDefault();
      menu.open = false;
      menu.querySelector('summary').focus();
      return;
    }
    const navigation = event.target.closest('.umg-nav');
    const toggle = navigation?.querySelector('[data-umg-menu-toggle]');
    if (!toggle || toggle.getAttribute('aria-expanded') !== 'true') return;
    event.preventDefault();
    setMenuExpanded(toggle, false);
    toggle.focus();
  });

  window.matchMedia('(max-width: 850px)').addEventListener('change', () => {
    document.querySelectorAll('[data-umg-menu-toggle]').forEach(toggle => setMenuExpanded(toggle, false));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMenus, { once: true });
  else initializeMenus();
  document.addEventListener('shopify:section:load', initializeMenus);
  window.addEventListener('popstate', updateCurrentMenuLink);
  window.addEventListener('pageshow', updateCurrentMenuLink);

  } catch(e) { console.error(e); }
})();
})();
